import React from "react";
import Header from "../common/Header";
import Bag from "../assets/img/bag.png";
import Hold from "../assets/img/hold.png";
import Wallet from "../assets/img/wallet.png";

function AboutPage() {
    return (
        <div>
            <Header />
            <section className="hero-section">
                <div className="container">
                    <div className="gradient"></div>
                    <div className="row">
                        <div className="col text-center">
                            <h2
                                className="hero-text"
                                data-aos="fade-right"
                                data-aos-duration="2000"
                            >
                                Redefining Digital Asset Exchange for 2026
                            </h2>
                            <p className="hero-subtext" data-aos="fade-up">
                                Xtrava Africa is a leading financial technology platform dedicated to
                                bridging the gap between digital assets and traditional fiat currency.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="exchange-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 d-none d-lg-block">
                            <img
                                src={Bag}
                                className="img-fluid"
                                data-aos="fade-up"
                                alt="Financial Growth"
                            />
                        </div>
                        <div className="col-lg-6">
                            <h3 className="card-title" data-aos="fade-down">Our Mission</h3>
                            <p className="card-text" data-aos="fade-up">
                                Our mission is to provide a secure, transparent, and ultra-fast
                                environment for users to liquidate their cryptocurrency holdings.
                                We believe that financial freedom should be accessible to everyone,
                                which is why we offer the most competitive rates in the market
                                with zero hidden fees.
                            </p>
                            <div className="mt-4">
                                <img src={Hold} data-aos="fade-in" style={{ width: '60px' }} alt="Reliability" />
                                <h5 className="mt-2">Integrity & Transparency</h5>
                                <p className="text-muted">
                                    Every transaction on Xtrava Africa is backed by top-tier liquidity providers
                                    ensuring that your settlements are processed within minutes.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="wallet-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <h3 className="card-title text-white" data-aos="fade-down">Why Choose Xtrava Africa?</h3>
                            <div className="row mt-4">
                                <div className="col-md-6 mb-3">
                                    <h5 className="text-white">Instant Settlement</h5>
                                    <p className="text-white-50">Say goodbye to waiting days for your bank alerts. We process outbound disbursements in real-time.</p>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <h5 className="text-white">Global Reach</h5>
                                    <p className="text-white-50">With our multi-currency virtual cards, you can spend your assets anywhere in the world.</p>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <h5 className="text-white">Bank-Grade Security</h5>
                                    <p className="text-white-50">We utilize multi-factor authentication and AES-256 encryption to keep your assets safe.</p>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <h5 className="text-white">24/7 Support</h5>
                                    <p className="text-white-50">Our dedicated support team is always ready to assist you with any inquiries or issues.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center" data-aos="fade-in">
                            <img
                                className="wallet-img"
                                src={Wallet}
                                alt="Secure Wallet"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="start-section py-5">
                <div className="container text-center">
                    <h2 className="card-title mb-4" data-aos="fade-down">Our 2025 Milestones</h2>
                    <div className="row mt-5">
                        <div className="col-md-4" data-aos="zoom-in">
                            <h3 className="hero-text text-primary">10k+</h3>
                            <p className="bullet-main-subtext">Active Users</p>
                        </div>
                        <div className="col-md-4" data-aos="zoom-in" data-aos-delay="200">
                            <h3 className="hero-text text-primary">₦200M+</h3>
                            <p className="bullet-main-subtext">Processed Volume</p>
                        </div>
                        <div className="col-md-4" data-aos="zoom-in" data-aos-delay="400">
                            <h3 className="hero-text text-primary">99.9%</h3>
                            <p className="bullet-main-subtext">Uptime Record</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="footer-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Xtrava Africa</p>
                            <p className="footer-link"><a href="/">Home</a></p>
                            <p className="footer-link"><a href="/about">About Us</a></p>
                            <p className="footer-link"><a href="/contact">Contact Us</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Services</p>
                            <p className="footer-link"><a href="/">Crypto Exchange</a></p>
                            <p className="footer-link"><a href="/">Virtual Cards</a></p>
                            <p className="footer-link"><a href="/">Bureau de Change</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Legal</p>
                            <p className="footer-link"><a href="/">Privacy Policy</a></p>
                            <p className="footer-link"><a href="/">Terms of Service</a></p>
                        </div>
                        <div className="col-lg-3 col-md-12">
                            <p className="footer-header">Location</p>
                            <p className="footer-link">Lagos, Nigeria</p>
                            <br />
                            <p className="footer-header">Telephone</p>
                            <p className="footer-link">+2347041010050</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default AboutPage;